import React, { useState } from 'react';
import { func, string, shape, bool } from 'prop-types';
import { reportToSegment, types, eventNames } from '@smartcar/morse';

import Modal from '../Modal';
import HubspotForm from './HubspotForm';
import Spinner from '../Spinner';

const HubspotFormModal = ({
  toggleModal, title, formConfig, prefill,
}) => {
  const [isLoading, setIsLoading] = useState(true);

  const handleClose = () => {
    reportToSegment(types.TRACK, eventNames.modalClosed, {
      label: 'hubspot contact form',
      title,
    });
    toggleModal();
  };

  const content = (
    <div>
      {isLoading && <Spinner size="small" />}
      <div style={{ display: isLoading ? 'none' : 'block' }}>
        <HubspotForm
          formConfig={formConfig}
          onReady={() => setIsLoading(false)}
          prefill={prefill}
          onSubmit={handleClose}
        />
      </div>
    </div>
  );

  return (
    <Modal
      title={title}
      content={content}
      toggleModal={handleClose}
    />
  );
};

HubspotFormModal.propTypes = {
  toggleModal: func.isRequired,
  title: string,
  formConfig: shape({
    portalId: string.isRequired,
    formId: string.isRequired,
    additionalOptions: shape({}),
  }),
  prefill: bool,
};

HubspotFormModal.defaultProps = {
  title: '',
  formConfig: {
    additionalOptions: {},
  },
  prefill: false,
};

export default HubspotFormModal;
